import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDesignations } from "../../redux/actions/designationActions";
import theme from "../../components/shared/theme";
import { thStyle, tdStyle } from "../../components/shared/themeStyles";

const Designations = () => {
  const dispatch = useDispatch();
  const { designations, loading, error } = useSelector((state) => state.designation);

  useEffect(() => {
    dispatch(fetchDesignations());
  }, [dispatch]);

  // Optional: sort alphabetically
  const sortedDesignations = [...designations].sort((a, b) => a.localeCompare(b));

  return (
    <div
      style={{
        backgroundColor: theme.colors.background,
        padding: theme.spacing.md,
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          fontSize: theme.font.size["2xl"],
          fontWeight: theme.font.weight.bold,
          marginBottom: theme.spacing.md,
        }}
      >
        Designation List
      </h1>

      {loading ? (
        <p style={{ fontSize: theme.font.size.base }}>Loading designations...</p>
      ) : error ? (
        <div
          style={{
            backgroundColor: theme.colors.dangerLight,
            border: `1px solid ${theme.colors.danger}`,
            color: theme.colors.dangerText,
            padding: theme.spacing.sm,
            borderRadius: theme.radius.md,
          }}
        >
          Error: {error}
        </div>
      ) : (
        <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
          <table className="min-w-[600px] w-full text-sm text-left">
            <thead style={{ backgroundColor: theme.colors.grayDark, color: "white" }}>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Designation Name</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {sortedDesignations.map((designation, index) => (
                <tr key={`${designation}-${index}`} className="hover:bg-gray-50">
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={tdStyle}>{designation}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Designations;
// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchAdminDesignations } from "../../redux/actions/designationActions";
// import theme from "../../components/shared/theme";
// import { thStyle, tdStyle } from "../../components/shared/themeStyles";

// const Designations = () => {
//   const dispatch = useDispatch();

//   const { adminDesignations, loadingAdmin, error } = useSelector(
//     (state) => state.designation
//   );

//   useEffect(() => {
//     dispatch(fetchAdminDesignations());
//   }, [dispatch]);

//   // Sort alphabetically by name
//   const sortedDesignations = [...adminDesignations].sort((a, b) =>
//     a.name.localeCompare(b.name)
//   );

//   return (
//     <div
//       style={{
//         backgroundColor: theme.colors.background,
//         padding: theme.spacing.md,
//         minHeight: "100vh",
//       }}
//     >
//       <h1
//         style={{
//           fontSize: theme.font.size["2xl"],
//           fontWeight: theme.font.weight.bold,
//           marginBottom: theme.spacing.md,
//         }}
//       >
//         Designation List (Admin)
//       </h1>

//       {loadingAdmin ? (
//         <p style={{ fontSize: theme.font.size.base }}>Loading designations...</p>
//       ) : error ? (
//         <div
//           style={{
//             backgroundColor: theme.colors.dangerLight,
//             border: `1px solid ${theme.colors.danger}`,
//             color: theme.colors.dangerText,
//             padding: theme.spacing.sm,
//             borderRadius: theme.radius.md,
//           }}
//         >
//           Error: {error}
//         </div>
//       ) : (
//         <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
//           <table className="min-w-[600px] w-full text-sm text-left">
//             <thead style={{ backgroundColor: theme.colors.grayDark, color: "white" }}>
//               <tr>
//                 <th style={thStyle}>#</th>
//                 <th style={thStyle}>ID</th>
//                 <th style={thStyle}>Designation Name</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {sortedDesignations.map((designation, index) => (
//                 <tr key={designation.id} className="hover:bg-gray-50">
//                   <td style={tdStyle}>{index + 1}</td>
//                   <td style={tdStyle}>{designation.id}</td>
//                   <td style={tdStyle}>{designation.name}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Designations;
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchAdminDesignations,
//   updateDesignation,
// } from "../../redux/actions/designationActions";
// import theme from "../../components/shared/theme";
// import { thStyle, tdStyle } from "../../components/shared/themeStyles";

// const Designations = () => {
//   const dispatch = useDispatch();

//   const { adminDesignations, loadingAdmin, error, updating } = useSelector(
//     (state) => state.designation
//   );

//   // Modal states
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editData, setEditData] = useState({ id: "", name: "", status: 1 });

//   useEffect(() => {
//     dispatch(fetchAdminDesignations());
//   }, [dispatch]);

//   const sortedDesignations = [...adminDesignations].sort((a, b) =>
//     a.name.localeCompare(b.name)
//   );

//   const openEditModal = (designation) => {
//     setEditData({
//       id: designation.id,
//       name: designation.name,
//       status: designation.status ?? 1,
//     });
//     setIsModalOpen(true);
//   };

//   const handleUpdate = () => {
//     dispatch(updateDesignation(editData.id, editData));
//     setIsModalOpen(false);
//   };

//   return (
//     <div
//       style={{
//         backgroundColor: theme.colors.background,
//         padding: theme.spacing.md,
//         minHeight: "100vh",
//       }}
//     >
//       <h1
//         style={{
//           fontSize: theme.font.size["2xl"],
//           fontWeight: theme.font.weight.bold,
//           marginBottom: theme.spacing.md,
//         }}
//       >
//         Designation List (Admin)
//       </h1>

//       {loadingAdmin ? (
//         <p>Loading...</p>
//       ) : error ? (
//         <p style={{ color: "red" }}>Error: {error}</p>
//       ) : (
//         <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
//           <table className="min-w-[600px] w-full text-sm text-left">
//             <thead style={{ backgroundColor: theme.colors.grayDark, color: "white" }}>
//               <tr>
               
//                 <th style={thStyle}>ID</th>
//                 <th style={thStyle}>Designation</th>
//                 <th style={thStyle}>Status</th>
//                 <th style={thStyle}>Action</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-gray-200">
//               {sortedDesignations.map((d, index) => (
//                 <tr key={d.id} className="hover:bg-gray-50">
                 
//                   <td style={tdStyle}>{d.id}</td>
//                   <td style={tdStyle}>{d.name}</td>
//                   <td style={tdStyle}>{d.status === 1 ? "Active" : "Inactive"}</td>

//                   <td style={tdStyle}>
//                     <button
//                       onClick={() => openEditModal(d)}
//                       className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
//                     >
//                       Edit
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* ---------------------- EDIT MODAL ---------------------- */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-96">
//             <h2 className="text-lg font-semibold mb-4">Edit Designation</h2>

//             <label className="block mb-2">Designation Name</label>
//             <input
//               type="text"
//               value={editData.name}
//               onChange={(e) =>
//                 setEditData({ ...editData, name: e.target.value })
//               }
//               className="border p-2 rounded w-full mb-4"
//             />

//             <label className="block mb-2">Status</label>
//             <select
//               value={editData.status}
//               onChange={(e) =>
//                 setEditData({ ...editData, status: Number(e.target.value) })
//               }
//               className="border p-2 rounded w-full mb-4"
//             >
//               <option value={1}>Active</option>
//               <option value={0}>Inactive</option>
//             </select>

//             <div className="flex justify-end gap-3">
//               <button
//                 onClick={() => setIsModalOpen(false)}
//                 className="px-4 py-2 bg-gray-400 text-white rounded"
//               >
//                 Cancel
//               </button>

//               <button
//                 onClick={handleUpdate}
//                 disabled={updating}
//                 className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
//               >
//                 {updating ? "Updating..." : "Update"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Designations;
